module.exports = __webpack_public_path__ + "static/media/notpragram1.a17876d7.png";